module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAkCAYAAADPRbkKAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEBSURBVHgB7ZmNCYMwEIVP6QCO4Ah2A7tJO2FHMBu0I2QD3SB9B6G00fhXaHJyHxwc5g7uoRfihQg45xpYB+udDDpYzbUX3nnAKpLFALuwgA5OSzIxLMAFDy3lS0XBlzISUADKmLDekoQjXsApfIA31JIgpppYFNoDqVEBqVEBqVEBqTneUUJPo39GBaTmeE0c4n/668iyQc/ffBzH3GnbdOOdv5tw4LK0HouHe3U7oI2E+doDqVkjYJhZsxF/LZZ+ZHEu5JuzjuRbhNuP2Ja28ZW/hlG9SwJyQ48SuTE12OppvnGz4hDj9QYOi5B4wXEusek82YEZkgEXbohvZ7AFvwD7p4k17KVsPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/credit.png
// module id = o03I
// module chunks = 1